import { memo } from "react";

const BotPreviewLayout = ({ children }) => {
  return <>{children}</>;
};
export default memo(BotPreviewLayout);
